<template>
  <layout-page name="not-found">
    <div class="mb-3 pt-5 text-center">
      <h2 class="mb-3">{{ $t("views.not_found.title") }}</h2>
      <icon-button variant="primary" to="/" icon="house-door-fill">{{
        $t("views.not_found.buttons.home")
      }}</icon-button>
    </div>

    <div class="col col-lg-8 col-12" style="margin: 0 auto">
      <b-card>
        {{ $t("views.not_found.broken_link_message") | capitalize }}
        <ul>
          <li>
            <a :href="$t('conditions.general_conditions_url')">{{
              $t("conditions.general_conditions_name") | capitalize
            }}</a>
          </li>
          <li>
            <a :href="$t('conditions.privacy_policy_url')">{{
              $t("conditions.privacy_policy_name") | capitalize
            }}</a>
          </li>
          <li>
            <a :href="$t('conditions.insurance_conditions_url')">{{
              $t("conditions.insurance_conditions_name") | capitalize
            }}</a>
          </li>
        </ul>
      </b-card>
    </div>
  </layout-page>
</template>

<script>
import IconButton from "@/components/shared/IconButton.vue";

export default {
  name: "NotFound",
  components: { IconButton },
};
</script>

<style lang="scss"></style>
